export const VIDFLEET_CONFIGURATION_LOAD = "VIDFLEET_CONFIGURATION_LOAD";
export const VIDFLEET_CONFIGURATION_LOAD_RESULT = "VIDFLEET_CONFIGURATION_LOAD_RESULT";
export const VIDFLEET_CONFIGURATION_SAVE = "VIDFLEET_CONFIGURATION_SAVE";
export const VIDFLEET_CONFIGURATION_SAVE_RESULT = "VIDFLEET_CONFIGURATION_SAVE_RESULT";
export const VIDFLEET_CONFIGURATION_GET_DEVICE_INFO = "VIDFLEET_CONFIGURATION_GET_DEVICE_INFO";
export const VIDFLEET_CONFIGURATION_GET_DEVICE_INFO_RESULT = "VIDFLEET_CONFIGURATION_GET_DEVICE_INFO_RESULT";
export const VIDFLEET_CONFIGURATION_SETTINGS_TO_CLONE = "VIDFLEET_CONFIGURATION_SETTINGS_TO_CLONE";
export const VIDFLEET_CONFIGURATION_SETTINGS_TO_CLONE_RESULT = "VIDFLEET_CONFIGURATION_SETTINGS_TO_CLONE_RESULT";

export const VIDFLEET_CONFIGURATION_BULK_MODAL_SHOW = "VIDFLEET_CONFIGURATION_BULK_MODAL_SHOW";
export const VIDFLEET_CONFIGURATION_BULK_MODAL_HIDE = "VIDFLEET_CONFIGURATION_BULK_MODAL_HIDE";
